<template lang="pug">
#base-header
    .view-container
        .base-container
            .base-title-container
                h1.base__title
                    i.voltar.mdi.mdi-arrow-left-thick(
                        v-if='voltarPara',
                        @click='irParaRota(voltarPara)'
                    )
                    | {{ titulo }}

</template>

<script>
export default {
    name: 'BaseHeaderVisaoGeral',
    emits: ['btnHeaderClicado'],
    props: {
        titulo: {
            type: String,
            default: () => ''
        },
        voltarPara: {
            type: [Object, Boolean, String],
            default: () => null
        },
        breadcrumb: {
            type: Array,
            default: () => []
        },
        btnTexto: {
            type: String,
            default: () => ''
        },
        icon: {
            type: String,
            default: () => ''
        },
        exibeBotao: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        irParaRota(rota) {
            if (!rota) return;
            if (typeof rota === 'boolean' && rota) {

                this.$router.go(-1);

            } else if (typeof rota === 'string' && rota === 'emit') {

                this.$emit('voltarClicado');

            } else if (this.$route.name !== rota.route) {

                this.$router.push({ name: rota.route });

            }
        },
        selecaoAcao(rota) {
            this.$router.push({ name: rota });
        }
    }
};
</script>

<style lang="scss" scoped>
#base-header {
    background: var(--white);
    box-shadow: 0 1px 3px 0 var(--block-shadow);
    .base-container {
        width: 100%;
        min-height: 87px;
        background: var(--white);
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        .base__title {
            display: flex;
            align-items: center;
            .voltar {
                cursor: pointer;
                font-size: 27px;
                color: #303133;
            }
            .voltar:hover {
                color: var(--secondary);
            }
        }
        .base-title-container {
            display: flex;
            flex-direction: column;
            .base__title {
                font-weight: 600;
            }
            .base__breadcrumb {
                margin-top: 8px;
                span.link-breadcrumb {
                    color: #1989fa;
                    text-decoration: underline;
                    cursor: pointer;
                }
                span.link-breadcrumb:hover {
                    color: var(--secondary);
                }
            }
        }
    }
    .button-outline {
        border-color: var(--secondary-two) !important;
        color: var(--white) !important;
        background: var(--secondary-two) !important;
    }
}
</style>
